import { useMemo } from "react";

// Gold ember particles drifting slowly upward.
export const Particles = ({ count = 26 }) => {
  const items = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => {
        const size = Math.random() * 3 + 1.5;
        return {
          id: i,
          left: Math.random() * 100,
          size,
          duration: Math.random() * 18 + 14,
          delay: Math.random() * -30,
          drift: `${(Math.random() - 0.5) * 120}px`,
          opacity: Math.random() * 0.3 + 0.12,
        };
      }),
    [count],
  );

  return (
    <div
      className="pointer-events-none fixed inset-0 z-[1] overflow-hidden"
      aria-hidden="true"
      data-testid="particles-layer"
    >
      {items.map((p) => (
        <span
          key={p.id}
          className="absolute bottom-[-10px] rounded-full"
          style={{
            left: `${p.left}%`,
            width: p.size,
            height: p.size,
            background: "#F5C542",
            boxShadow: "0 0 8px 1px rgba(245, 197, 66,0.6)",
            animation: `floatUp ${p.duration}s linear ${p.delay}s infinite`,
            "--p-drift": p.drift,
            "--p-opacity": p.opacity,
          }}
        />
      ))}
    </div>
  );
};
